/**
 * StepsList — renders an LLM step-by-step analysis. Thin wrapper over the
 * existing `StepsAnalysis` component in `question-result/`. Lives here in
 * `feedback-analysis/sections/` as the canonical section name; the underlying
 * component is unchanged so callers that already import it directly still work.
 *
 * Kept as a wrapper rather than a move so this refactor introduces no churn
 * for existing imports. A follow-up can collapse the wrapper once nothing
 * imports `@shared-ui/question-result/StepsAnalysis` directly.
 */
import { StepsAnalysis, type StepItem, type StepsAnalysisProps } from '../../question-result/StepsAnalysis';

export type { StepItem, StepsAnalysisProps };

export function StepsList(props: StepsAnalysisProps) {
    return <StepsAnalysis {...props} />;
}
